import { DELAY_REASONS, normalizeDelayReasonCode } from "@/constants";
import { formatDate, getDateByTimeZone } from "@/lib/date";

import BaseModel from "./base-model";
import { parseDeliveryStatus, renderStatus } from "./Delivery";

const LIST_STATUS_LABEL = {
  inProgress: "배송완료 전",
  completed: "배송완료",
  sentBack: "반송완료",
  lost: "분실완료",
  canceled: "취소",
};

export default class SentBackDelivery extends BaseModel {
  getEtc4Obj() {
    if (this._etc4Obj) {
      return this._etc4Obj;
    }

    if (!this.etc4) {
      this._etc4Obj = {};
      return this._etc4Obj;
    }

    if (typeof this.etc4 === "object") {
      this._etc4Obj = this.etc4;
      return this._etc4Obj;
    }

    try {
      this._etc4Obj = JSON.parse(this.etc4);
    } catch (_e) {
      this._etc4Obj = {};
    }

    return this._etc4Obj;
  }

  renderDateTime(value) {
    if (!value) {
      return "";
    }

    return formatDate(getDateByTimeZone(value), "yyyy-MM-dd HH:mm");
  }

  renderBookId() {
    return this.bookId || this.delivery?.bookId || "";
  }

  renderOrderIdFromCorp() {
    return this.orderIdFromCorp || this.delivery?.orderIdFromCorp || "";
  }

  renderOrderIdFromCorpSub() {
    return this.orderIdFromCorpSub || this.delivery?.orderIdFromCorpSub || "";
  }

  getRawDeliveryStatus() {
    return this.deliveryStatus ?? this.status ?? this.delivery?.status;
  }

  renderDeliveryStatus() {
    const status = this.getRawDeliveryStatus();

    if (status == null || status === "") {
      return "";
    }

    if (LIST_STATUS_LABEL[status]) {
      return LIST_STATUS_LABEL[status];
    }

    if (typeof status === "number" || /^\d+$/.test(String(status))) {
      return renderStatus(parseDeliveryStatus(status));
    }

    const labeled = renderStatus(status);

    return labeled === "접수" && status !== "DELIVERY_STATUS_RECEIPT"
      ? status
      : labeled;
  }

  renderSentBackReason() {
    const etc4 = this.getEtc4Obj();
    const text =
      this.sentBackReason ||
      etc4.sentBackReason ||
      this.reason ||
      "";

    if (text) {
      return text;
    }

    const code = normalizeDelayReasonCode(
      this.sentBackReasonCode || etc4.sentBackReasonCode || "",
    );

    if (!code) {
      return "";
    }

    return DELAY_REASONS.find((item) => item.code === code)?.text || code;
  }

  renderSentBackAt() {
    return this.renderDateTime(
      this.sentBackAt || this.sentBackDate || this.deliveryCompletedDate,
    );
  }

  renderLatestCommentWriterName() {
    return (
      this.latestCommentWriterName || this.latestComment?.writerName || ""
    );
  }

  renderLatestCommentCreatedAt() {
    return this.renderDateTime(
      this.latestCommentCreatedAt || this.latestComment?.createdAt,
    );
  }

  renderCommentConfirmed() {
    const value =
      this.commentConfirmed ??
      this.latestCommentConfirmed ??
      this.latestComment?.isConfirmed;

    if (value == null) {
      return "";
    }

    return value ? "확인" : "미확인";
  }
}
